import React from "react";
import { cloneElement } from "react";
import { Box, Typography, List, ListItem, Grid } from "@mui/material";
import logo from '../../assets/logo.png'


const addNumbersToListItems = (list) => {
  const getAlphabet = (index) => String.fromCharCode(97 + index); // 'a' + index for alphabetic order

  const addAlphabetToNestedList = (children) => {
    return React.Children.map(children, (child, index) => {
      if (child.type === ListItem) {
        return cloneElement(child, {
          children: (
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
              <Typography
                variant="body1"
                component="span"
                style={{
                  fontWeight: "bold",
                  marginRight: "8px",
                }}
                className="link-color"
              >
                {getAlphabet(index)}.
              </Typography>
              <Box>{child.props.children}</Box>
            </Box>
          ),
        });
      }
      return child;
    });
  };

  return cloneElement(list, {
    children: React.Children.map(list.props.children, (child, index) => {
      if (child.type === ListItem) {
        const nestedList = React.Children.toArray(child.props.children).find(
          (nestedChild) => nestedChild.type === List
        );

        if (nestedList) {
          const updatedNestedList = addAlphabetToNestedList(
            nestedList.props.children
          );

          return cloneElement(child, {
            children: (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <Typography
                    variant="body1"
                    component="span"
                    style={{
                      fontWeight: "bold",
                      marginRight: "8px",
                    }}
                    className="link-color"
                  >
                    {index + 1}.
                  </Typography>
                  <Box>
                    {React.Children.toArray(child.props.children).filter(
                      (nestedChild) => nestedChild.type !== List
                    )}
                  </Box>
                </Box>
                <List>{updatedNestedList}</List>
              </Box>
            ),
          });
        } else {
          return cloneElement(child, {
            children: (
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <Typography
                  variant="body1"
                  component="span"
                  style={{
                    fontWeight: "bold",
                    marginRight: "8px",
                  }}
                  className="link-color"
                >
                  {index + 1}.
                </Typography>
                <Box>{child.props.children}</Box>
              </Box>
            ),
          });
        }
      }
      return child;
    }),
  });
};

const PrivacyPolicy = () => {
  const list = (
    <List className="policy-list-content">
      <ListItem>
        <Typography className="link-color-head">
          Information We Collect
        </Typography>
        <List>
          <ListItem>
            <Typography className="link-alpha-head">
              Personal Information:
            </Typography>
            <Box className="policy-container">
              <Typography className="policy-item" >
                Information Collected During Registration
              </Typography>

              <Typography className="policy-item">
                When you register, we collect personal information including your:
              </Typography>

              <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
                <li>Email address</li>
                <li>Username</li>
                <li>Password</li>
              </Typography>

              <Typography className="policy-item">
                This information is required to create and manage your account.
              </Typography>
            </Box>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">Usage Data:</Typography>
            <Typography className="policy-item">
              {" "}
              <Typography className="policy-item">
                We collect information about how you use the Services, such as:
              </Typography>

              <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
                <li>Essay submissions</li>
                <li>AI tutor interactions</li>
                <li>User prompt responses</li>
                <li>Session durations and frequency</li>
              </Typography>
              <Typography className="policy-item">
                This helps us tailor and enhance your experience.
              </Typography>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              Payment Information:
            </Typography>{" "}
            <Typography className="policy-item">
              When you purchase a paid plan, we collect:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Credit/debit card details</li>
              <li>Billing address</li>

            </Typography>
            <Typography className="policy-item">
              Payments are processed securely by third-party providers. We do not store full card information.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              Feedback and Communication:{" "}
            </Typography>{" "}
            <Typography className="policy-item">
              We collect data from:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Customer support communications</li>
              <li>Feedback forms</li>
              <li>Surveys and direct contact</li>

            </Typography>

          </ListItem>
        </List>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head">
          How We Use Your Information
        </Typography>
        <List>
          <ListItem>
            <Typography className="link-alpha-head">
              To Provide Services:
            </Typography>
            <Typography className="policy-item">
              We use your data to:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Manage your account</li>
              <li>Process payments</li>
              <li>Enable platform functionality</li>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              To Improve and Develop:
            </Typography>
            <Typography className="policy-item">
              We analyze usage to:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Understand engagement</li>
              <li>Improve platform features</li>
              <li>Fix bugs and ensure quality</li>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              For Communication:
            </Typography>{" "}
            <Typography className="policy-item">
              We may contact you regarding:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Account status and updates</li>
              <li>Security alerts</li>
              <li>Customer support responses</li>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">For Marketing:</Typography>{" "}
            <Typography className="policy-item">
              With your explicit consent, we may send:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Newsletters</li>
              <li>Promotions</li>
              <li>Updates on new features</li>
            </Typography>
            <Typography className="policy-item">
              You can opt out at any time.
            </Typography>
          </ListItem>
        </List>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head">
          Sharing Your Information
        </Typography>{" "}
        <Typography className="policy-item">
          We do not sell or rent your personal information. We may share data with:
        </Typography>

        <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
          <li>Hosting and infrastructure providers</li>
          <li>Payment processors </li>
          <li>Service partners under strict confidentiality agreements</li>
        </Typography>
        <Typography className="policy-item">
          All partners are contractually obligated to protect your information.
        </Typography>

      </ListItem>
      <ListItem>
        <Typography className="link-color-head">Data Security</Typography>{" "}
        <Typography className="policy-item">
          We implement administrative, technical, and physical security measures to protect your data, including:
        </Typography>

        <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
          <li>SSL encryption</li>
          <li>Access controls </li>
          <li>Regular backups</li>
        </Typography>
        <Typography className="policy-item">
          While we strive to protect your information, no system is completely secure.
        </Typography>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head">Your Rights</Typography>{" "}
        <Typography className="policy-item">
          You have the right to:
        </Typography>

        <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
          <li>Access the personal data we hold about you</li>
          <li>Update inaccurate information </li>
          <li>Request deletion of your data</li>
        </Typography>
        <Typography className="policy-item">
          Contact us at <span className="link-redirect" >info@rayiqlive.com</span> to exercise these rights. We will respond within a reasonable time and in accordance with applicable laws..
        </Typography>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head">
          Changes to Our Privacy Policy
        </Typography>{" "}
        <Typography className="policy-item">
          We may update this Privacy Policy periodically. When we do:
        </Typography>

        <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
          <li>The “Effective Date” at the top will change</li>
          <li>Material updates will be announced via email or platform notification </li>
        </Typography>
        <Typography className="policy-item">
          We recommend reviewing this policy regularly.
        </Typography>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head">Contact Us</Typography>{" "}

        <Typography className="policy-item">
          If you have questions or concerns about this policy or your data, contact us at:
        </Typography>

        <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
          <li>📧 Email: <span className="link-redirect" >info@rayiqlive.com</span></li>
          <li>🌐 Website: <a href="https://www.rayiqlive.com" className="link-redirect" target="_blank" rel="noopener noreferrer">www.rayiqlive.com</a>  </li>
        </Typography>
      </ListItem>
      <ListItem>
        <Typography className="link-color-head"> Florida Privacy Rights</Typography>{" "}

        <Typography className="policy-item">
          If you reside in Florida, you are entitled to additional rights under Florida law:
        </Typography>
        <List>
          <ListItem>
          <Typography className="link-alpha-head"> Data Security (FIPA Compliance)</Typography>{" "}
            <Typography className="policy-item">
              We comply with the Florida Information Protection Act (FIPA) and take reasonable measures to safeguard your personal data. If a breach occurs involving 500 or more Florida residents, we will notify affected users and the Florida Attorney General within the required timeframe.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              Access and Correction:
            </Typography>
            <Typography className="policy-item">
              You may request access to the personal data we hold about you or request corrections to inaccurate information by emailing <span className="link-redirect" >info@rayiqlive.com</span>.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">
              Right to Deletion:
            </Typography>{" "}
            <Typography className="policy-item">
              You may request that we delete your personal data. We will comply unless retention is required for:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Legal or regulatory compliance</li>
              <li>Completing a transaction you initiated</li>
              <li>Detecting or preventing fraud or security issues</li>
              <li>Internal business purposes aligned with your expectations</li>
              <li>Defending legal claims</li>
              <li>Archived backups where deletion is not immediately feasible</li>
            </Typography>
          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">Right to Opt Out of Marketing:</Typography>{" "}
            <Typography className="policy-item">
              You can opt out of promotional communications by:
            </Typography>

            <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
              <li>Clicking “unsubscribe” in any marketing email</li>
              <li>Contacting <span className="link-redirect" >info@rayiqlive.com</span></li>
            </Typography>

          </ListItem>
          <ListItem>
            <Typography className="link-alpha-head">Fair Data Practices (FDUTPA Compliance):</Typography>{" "}
            <Typography className="policy-item">
              We follow the Florida Deceptive and Unfair Trade Practices Act (FDUTPA) by being transparent, fair, and honest about how we collect, use, and protect your personal data.
            </Typography>
          </ListItem>
        </List>
      </ListItem>

    </List>
  );

  const numberedList = addNumbersToListItems(list);

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh", // Ensure it covers the full height of the viewport
          padding: "16px",
        }}
      >
        <Box sx={{ maxWidth: "1000px", margin: "auto" }}>
          <Box className="policy-content-header-title">
            <Box class="setting-icon">
              <img src={logo} alt="app-logo" loading="lazy" />
            </Box>
            <Typography variant="h2" component="h2" className="link-color">
              PRIVACY POLICY
            </Typography>
          </Box>
          <Box className="policy-content-layout">
            <Box variant="div" component="div" className="createuser-wrap">
              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={12}>
                  <Box variant="div" component="div" className="user-detail">
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12} lg={12}>
                        <Box variant="div" component="div">
                          <Typography
                            variant="body1"
                            component="label"
                            className="label"
                          >
                            <Typography className="policy-item">
                              Effective Date: May 1, 2025
                            </Typography>
                            <Typography className="policy-item">
                              Jurisdiction: State of Florida, United States
                            </Typography>
                            <Typography className="policy-item">
                              Welcome to RayiqLive! Your privacy is important to us. This Privacy Policy explains how we collect, use, share, and protect your information when you interact with our website, services, marketing, and events (collectively, the “Services”).
                            </Typography>
                            <div className="policy-item">{numberedList}</div>
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          {/* <Footer /> */}
        </Box>
      </Box>
    </>
  );
};

export default PrivacyPolicy;
